// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__1cDc-","Title":"styles_Title__23Pj9"};